import "./QuantitySelector.scss";

const QuantitySelector = ({ value, onChange, min = 1, max = 100 }) => {
  const handleChange = (e) => {
    const num = parseInt(e.target.value) || min;
    onChange(Math.min(Math.max(num, min), max));
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  return (
    <div className="qty-selector">
      <button
        className="qty-selector__btn"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
      >
        -
      </button>
      <input
        type="number"
        className="qty-selector__input"
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        min={min}
        max={max}
      />
      <button
        className="qty-selector__btn"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
      >
        +
      </button>
    </div>
  );
};

export default QuantitySelector;
